var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "drop-shadow afterSave", attrs: { "max-width": "900" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
          _c("w-spacer"),
          _c("w-fa", {
            staticClass: "close-button",
            attrs: { icon: "times", right: "" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ],
        1
      ),
      _vm.isAllowed()
        ? _c(
            "div",
            [
              _c(
                "w-card-content",
                { staticClass: "address", attrs: { "no-padding": "" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { staticClass: "label", attrs: { sm: "2" } },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.mail.to")) + " ")]
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "10" } },
                        [
                          _c("w-input", {
                            attrs: { autocapitalize: "none", required: "" },
                            on: {
                              input: function ($event) {
                                return _vm.$emit("update:to", $event)
                              },
                            },
                            model: {
                              value: _vm.mailData.to,
                              callback: function ($$v) {
                                _vm.$set(_vm.mailData, "to", $$v)
                              },
                              expression: "mailData.to",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { staticClass: "label", attrs: { sm: "2" } },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.mail.cc")) + " ")]
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "10" } },
                        [
                          _c("w-input", {
                            attrs: { autocapitalize: "none", required: "" },
                            on: {
                              input: function ($event) {
                                return _vm.$emit("update:cc", $event)
                              },
                            },
                            model: {
                              value: _vm.mailData.cc,
                              callback: function ($$v) {
                                _vm.$set(_vm.mailData, "cc", $$v)
                              },
                              expression: "mailData.cc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { staticClass: "label", attrs: { sm: "2" } },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.mail.bcc")) + " ")]
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "10" } },
                        [
                          _c("w-input", {
                            attrs: { autocapitalize: "none", required: "" },
                            on: {
                              input: function ($event) {
                                return _vm.$emit("update:bcc", $event)
                              },
                            },
                            model: {
                              value: _vm.mailData.bcc,
                              callback: function ($$v) {
                                _vm.$set(_vm.mailData, "bcc", $$v)
                              },
                              expression: "mailData.bcc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { staticClass: "label", attrs: { sm: "2" } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$ct("common.mail.subject")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "10" } },
                        [
                          _c("w-input", {
                            attrs: { required: "" },
                            on: {
                              input: function ($event) {
                                return _vm.$emit("update:subject", $event)
                              },
                            },
                            model: {
                              value: _vm.mailData.subject,
                              callback: function ($$v) {
                                _vm.$set(_vm.mailData, "subject", $$v)
                              },
                              expression: "mailData.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-content",
                { staticClass: "message" },
                [
                  _c("vue-editor", {
                    staticClass: "html-editor",
                    model: {
                      value: _vm.mailData.body,
                      callback: function ($$v) {
                        _vm.$set(_vm.mailData, "body", $$v)
                      },
                      expression: "mailData.body",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-link",
                    {
                      staticClass: "mts",
                      on: {
                        click: function ($event) {
                          return _vm.download()
                        },
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("download")) + " "),
                      _c("w-fa", {
                        staticClass: "mls",
                        attrs: { icon: "external-link-alt" },
                      }),
                    ],
                    1
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { icon: "paper-plane" },
                      on: {
                        click: function ($event) {
                          return _vm.send()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.mail.send")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-card-content",
            [_c("app-missing-module", { attrs: { "module-id": 83 } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }